export const STAKEHOLDER_ROLES_V2 = {
  OWNER: 'OWNER',
  CONTROL_OVER_MANAGEMENT: 'CONTROL_OVER_MANAGEMENT',
  ULTIMATE_BENEFICIAL_OWNER: 'ULTIMATE_BENEFICIAL_OWNER',
  APPLICANT: 'APPLICANT',
  SOLE_TRADER: 'SOLE_TRADER',
  PARTNER: 'PARTNER',
};
export const ALL_ROLES = Object.values(STAKEHOLDER_ROLES_V2);

export const STAKEHOLDER_TYPES = {
  PERSON: 'PERSON',
  COMPANY: 'COMPANY',
};
